import { clsx } from "clsx";
import type { ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Our typography scale is named (`text-body-m-b`), not t-shirt sized, so
 * tailwind-merge files those utilities under `text-color` and lets them cancel
 * real colors — `text-primary-button-text text-body-m-b` used to resolve to no
 * color at all. Teaching it the token shape keeps size and color independent.
 */
const isTypographyToken = (value: string) =>
  /^(heading|body|english-body|caption)-/.test(value);

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [isTypographyToken] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
